import { QRCodeCanvas } from "qrcode.react";

function PaymentQRCode({ upiId, amount }) {
  const upiUrl = `upi://pay?pa=${upiId}&pn=YourStore&am=${amount}&cu=INR`;

  return (
    <div style={{ textAlign: "center", marginTop: 10 }}>
      <QRCodeCanvas value={upiUrl} size={120} includeMargin />
      <p style={{ fontSize: 12, marginTop: 4 }}>Scan & Pay via UPI</p>
    </div>
  );
}

export default PaymentQRCode;
